import React from 'react';
import { Phone } from 'lucide-react';
import { cn } from '@/lib/utils';
import { logger } from '@/utils/logger';

export interface PhoneLinkProps {
  phoneNumber: string;
  formatted: string;
  label?: string;
  showIcon?: boolean;
  className?: string;
  phoneType?: 'sales' | 'support';
  trackingContext?: string;
}

/**
 * Simple phone link component for footer and inline use
 */
export const PhoneLink = ({ 
  phoneNumber, 
  formatted, 
  label,
  showIcon = true,
  className,
  phoneType = 'sales',
  trackingContext = 'unknown'
}: PhoneLinkProps) => {
  
  const handlePhoneClick = () => {
    logger.userAction('phone_link_click', {
      phoneNumber,
      phoneType,
      context: trackingContext,
      timestamp: new Date().toISOString()
    });
  };

  return (
    <a
      href={phoneNumber}
      onClick={handlePhoneClick}
      className={cn(
        'inline-flex items-center gap-3 transition-all duration-300 group',
        'hover:transform hover:scale-105',
        className
      )}
    >
      {showIcon && (
        <div className={cn(
          'p-2 rounded-full transition-all duration-300',
          phoneType === 'sales' 
            ? 'bg-edgefi-purple/10 text-edgefi-purple group-hover:bg-edgefi-purple group-hover:text-white' 
            : 'bg-edgefi-blue/10 text-edgefi-blue group-hover:bg-edgefi-blue group-hover:text-white'
        )}>
          <Phone className="h-4 w-4" />
        </div>
      )}
      <div className="flex flex-col">
        {label && (
          <span className="text-xs font-medium uppercase tracking-wide text-black">{label}</span>
        )}
        <span className="font-bold text-gray-900 group-hover:text-gray-700 transition-colors">
          {formatted}
        </span>
      </div>
    </a>
  );
};

export default PhoneLink;